import { tags } from '@hungryroot/tags';

/** Mirrors v0 Preferences ProteinPreferences meat list. */
export const MEAT_PROTEIN_TAG_IDS = [
  tags.BeefAndBison,
  tags.Poultry,
  tags.Pork,
  tags.Lamb,
  tags.Bison,
  tags.Steak,
  tags.GroundBeef,
  tags.Turkey,
  tags.Chicken,
] as const;

/** Mirrors v0 Preferences ProteinPreferences seafood list. */
export const SEAFOOD_PROTEIN_TAG_IDS = [
  tags.Shellfish,
  tags.FreshFish,
  tags.SmokedFish,
  tags.Tuna,
  tags.Trout,
  tags.Whitefish,
  tags.Salmon,
] as const;

/** Plant-based egg — present in v0 PLANTS_TAGS, not named on `tags`. */
const PLANT_BASED_EGG_TAG_ID = 13;

/** Mirrors v0 Preferences ProteinPreferences plants list. */
export const PLANTS_PROTEIN_TAG_IDS = [
  tags.TofuAndTempeh,
  tags.BeansAndLentils,
  tags.MeatAlternatives,
  PLANT_BASED_EGG_TAG_ID,
  tags.DairyFreeCheese,
] as const;

export const PROTEIN_PREFERENCE_SECTIONS = [
  { key: 'meat', tagIds: MEAT_PROTEIN_TAG_IDS },
  { key: 'seafood', tagIds: SEAFOOD_PROTEIN_TAG_IDS },
  { key: 'plants', tagIds: PLANTS_PROTEIN_TAG_IDS },
] as const;

export const ALL_PROTEIN_PREFERENCE_TAG_IDS = [
  ...MEAT_PROTEIN_TAG_IDS,
  ...SEAFOOD_PROTEIN_TAG_IDS,
  ...PLANTS_PROTEIN_TAG_IDS,
];
